<h2 mat-dialog-title>An Error has occured</h2>
<mat-dialog-content>
@if(isNavigationError(this.data)) { 
    @switch (this.data.error.status) {
      @case (403){
        @if(!this.activeClient)
        {
          <span>Your user account has not been associated with any clients. Please contact support to resolve. 877.670.0637 support@hoganassessments.com</span>
        }
      }

      @case (500){
        <span>An intermittent error has occured. Please try again. If this issue persists please contact support. 877.670.0637 support@hoganassessments.com</span>
      }
    } 
}
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="logout()" cdkFocusInitial>Logout</button>
  <button matButton [class.hidden!]="hideRetry()" (click)="retry()" cdkFocusInitial>Retry</button>
</mat-dialog-actions>
